export const Heading = () => {
    return(
        <div>
            <h1 className="heading">JAKES ONLINE STORE</h1>
        </div>
    )
}